import script from "./ForgetPassword.vue?vue&type=script&lang=ts&setup=true"
export * from "./ForgetPassword.vue?vue&type=script&lang=ts&setup=true"

import "./ForgetPassword.vue?vue&type=style&index=0&id=06f8a92c&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f8a92c"]])

export default __exports__